export const activeInactiveOpt = [
    { value: '', label: 'Seleziona un valore', disabled: true},
    { value: 'active', label: 'Si'},
    { value: 'inactive', label: 'No'},
];
